/**
 * @generated SignedSource<<2ccef492f0734305361190e461562a7a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ClubLogo_Club$data = {
  readonly logoImage: {
    readonly publicId: string;
  } | null | undefined;
  readonly " $fragmentType": "ClubLogo_Club";
};
export type ClubLogo_Club$key = {
  readonly " $data"?: ClubLogo_Club$data;
  readonly " $fragmentSpreads": FragmentRefs<"ClubLogo_Club">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ClubLogo_Club",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "logoImage",
      "plural": false,
      "selections": [
        {
          "alias": "publicId",
          "args": null,
          "kind": "ScalarField",
          "name": "renderingKey",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Club",
  "abstractKey": null
};

(node as any).hash = "55d8e536484508649f0fb54be134ebb7";

export default node;
